import { Flex } from "@chakra-ui/react"
import { Ptext } from '../../../componentsF/Chakra3F/ChakraF.jsx'
import { QrCode } from "../../../componentsF/QrCodeF.tsx"

export const QrGameInvite = () => {
  return <>
    <Ptext {...{mt: 5, fontSize: '5xl'}}>Invite Player</Ptext>
    <Flex {...{my: 5, justifyContent: 'center'}}>
      <QrCode {...{value: location.href}} />
    </Flex>
  </>
}
